import {Component, ElementRef, HostListener, Input, ViewChild} from '@angular/core';
import {constants} from "../../../constants";
import {MetrikaService} from "../../../services/metrika.service";
import {SubscriberService} from "../../../services/subscriber.service";
import {Router} from "@angular/router";
import {MainPageBanner} from "../../../model/main-page-banner";


declare var $: any;


@Component({
  selector: 'app-privet-plus-banner',
  templateUrl: './privet-plus-banner.component.html',
  styleUrls: ['./privet-plus-banner.component.css']
})
export class PrivetPlusBannerComponent {
  @Input() specialBanners: ReadonlyArray<MainPageBanner>;
  private _bannerSlider: ElementRef;
  private sliderInit: boolean;

  readonly bannerClasses = ['offer-holidays_01', 'offer-holidays_02', 'offer-holidays_03', 'offer-holidays_04',
    'offer-holidays_05', 'offer-holidays_06', 'offer-holidays_07', 'offer-holidays_08', 'offer-holidays_09', 'offer-holidays_10']

  constructor(private metrikaService: MetrikaService,
              private subscriberService: SubscriberService,
              private router: Router) {
    this.sliderInit = false;
  }

  @ViewChild("banners") set hitsSlider(value: ElementRef) {
    this.removeSlider();

    this._bannerSlider = value;

    this.initHitsSlider()
  }

  @HostListener('window:resize')
  resize(): void {
    if (this._bannerSlider) {
      if (window.innerWidth > constants.desktopScreenBreakpoint) {
        this.updateSlider();
      }

      if (window.innerWidth <= constants.desktopScreenBreakpoint) {
        this.updateSlider();
      }
    }
  }

  initHitsSlider(): void {
    if (!this.sliderInit && this._bannerSlider) {
      $(this._bannerSlider.nativeElement).slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 7000,
        adaptiveHeight: true,
        responsive: true,
      });
      this.sliderInit = true;
    }
  }

  updateSlider(): void {
    this.removeSlider();
    this.initHitsSlider();
  }

  removeSlider(): void {
    if (this.sliderInit && this._bannerSlider) {
      $(this._bannerSlider.nativeElement).slick("unslick");
      this.sliderInit = false;
    }
  }

  redirectToAutoradio() {
    window.open(constants.autoRadioLink, '_blank');
    this.metrikaService.addEvent("redirect_to_autoradio_page", null, "SUCCESS", null, null, null)
  }

  addShowEvent() {
    this.metrikaService.addEvent("show_autoradio_banner_event", null, null, null)
  }

  redirectToUgc() {
    this.router.navigate(['/subscriber/ugc']);
  }

  activateService(): void {
    this.subscriberService.activateSubscriptionBanner();
  }

  getText(specialBanner: MainPageBanner) {
    return specialBanner.languageAttributes[0].title;
  }

  redirect(url: string) {
    if (url.includes("genres")) {
      let genreId = url.replace(/\D/g, '');
      this.router.navigate(['/genres'], {queryParams: {id: genreId}});
    } else {
      this.router.navigate([url]);
    }
  }
}
